module.exports = __webpack_public_path__ + "img/logo-mini.af3032d0.png";